"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var Easing = /*#__PURE__*/function () {
  function Easing() {
    (0, _classCallCheck2["default"])(this, Easing);
  }
  return (0, _createClass2["default"])(Easing, null, [{
    key: "ease",
    get: function get() {
      var _this = this;
      return function (p) {
        var oldValue = 0;
        var start = Date.now();
        var easingFn = _this.easing[p.easing] || _this.easing.linear;
        var process = function process() {
          var time = Date.now() - start;
          var eased = easingFn(time, 0, 1, p.duration);
          var value = 0 - p.length * eased;
          if (p.animate) p.animate(oldValue - value, value);
          oldValue = value;
          if (time < p.duration) {
            window.requestAnimationFrame(process);
          } else if (p.end) {
            p.end();
          }
        };
        if (p.start instanceof Function) p.start();
        process();
      };
    }
  }, {
    key: "easing",
    get: function get() {
      return {
        linear: function linear(t, b, c, d) {
          return c * t / d + b;
        },
        easeIn: function easeIn(t, b, c, d) {
          return Math.pow(t / d, 3);
        },
        easeOut: function easeOut(t, b, c, d) {
          return 1 - Math.pow(1 - t / d, 3);
        },
        easeInOutQuad: function easeInOutQuad(t, b, c, d) {
          var nt = t / (d / 2);
          if (nt < 1) {
            return c / 2 * nt * nt + b;
          }
          nt -= 1;
          return -c / 2 * (nt * (nt - 2) - 1) + b;
        },
        easeOutQuart: function easeOutQuart(t, b, c, d) {
          var nt = t / d;
          nt -= 1;
          return -c * (Math.pow(nt, 4) - 1) + b;
        }
      };
    }
  }]);
}();
var _default = exports["default"] = Easing;